import { Routes } from '@angular/router';

import { DeliveryStatisticsComponent } from './containers/delivery-statistics/delivery-statistics.component';
import { JumpstoryStatisticsComponent } from './containers/jumpstory-statistics/jumpstory-statistics.component';

export const DELIVERY_STATISTICS_ROUTES: Routes = [
  {
    path: 'jumpstory',
    component: JumpstoryStatisticsComponent,
  },
  {
    path: ':tool',
    component: DeliveryStatisticsComponent,
  },
];
